var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFullScreen = function SvgFullScreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.894 19.417a1.46 1.46 0 0 1 .526.874c.02.2.02.4.02.6v5a1.72 1.72 0 0 1-.3 1.1 1 1 0 0 0-.109.089 1 1 0 0 0-.109.1 2 2 0 0 1-1.13.208h-5a1.72 1.72 0 0 1-1.1-.3 1.47 1.47 0 0 1-.4-1.112 1.36 1.36 0 0 1 .516-.973 1.77 1.77 0 0 1 1-.209h4.062v-3.639a2.67 2.67 0 0 1 .3-1.549 1.5 1.5 0 0 1 1.748-.209Z",
    "data-name": "Path 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.616 19.417a1.5 1.5 0 0 1 .526.874c0 .159.01.308.01.457v4.062h3.646a2.67 2.67 0 0 1 1.549.3 1.47 1.47 0 0 1 .4 1.112 1.36 1.36 0 0 1-.516.973 2 2 0 0 1-1.132.219h-5a1.72 1.72 0 0 1-1.1-.3 1 1 0 0 0-.089-.109 1 1 0 0 0-.1-.109 2 2 0 0 1-.22-1.132v-5a1.72 1.72 0 0 1 .3-1.1 1.5 1.5 0 0 1 1.748-.209Z",
    "data-name": "Path 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.936 2.627h5a1.72 1.72 0 0 1 1.1.3 1 1 0 0 0 .089.109 1 1 0 0 0 .1.109 2 2 0 0 1 .219 1.132v5a1.72 1.72 0 0 1-.3 1.1 1.47 1.47 0 0 1-1.112.4 1.36 1.36 0 0 1-.973-.516 1.77 1.77 0 0 1-.209-1V5.189h-3.646a2.67 2.67 0 0 1-1.549-.3 1.47 1.47 0 0 1-.4-1.112 1.36 1.36 0 0 1 .516-.973 2 2 0 0 1 1.135-.217Z",
    "data-name": "Path 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.219 2.627h5a1.72 1.72 0 0 1 1.1.3 1.47 1.47 0 0 1 .4 1.112 1.36 1.36 0 0 1-.516.973 1.77 1.77 0 0 1-1 .209h-4.07v3.644a2.67 2.67 0 0 1-.3 1.549 1.47 1.47 0 0 1-1.112.4 1.36 1.36 0 0 1-.973-.516 2.43 2.43 0 0 1-.188-1.155v-5a1.72 1.72 0 0 1 .3-1.099 1 1 0 0 0 .107-.089 1 1 0 0 0 .109-.1 2 2 0 0 1 1.143-.228",
    "data-name": "Path 4"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h30v30H0z",
    "data-name": "Rectangle 1"
  })));
};
export default SvgFullScreen;